export const FETCH_USER_KUDOS_FOR_COURSE_START =
  'FETCH_USER_KUDOS_FOR_COURSE_START';
export const FETCH_USER_KUDOS_FOR_COURSE_SUCCESS =
  'FETCH_USER_KUDOS_FOR_COURSE_SUCCESS';
export const FETCH_USER_KUDOS_FOR_COURSE_FAILURE =
  'FETCH_USER_KUDOS_FOR_COURSE_FAILURE';
